var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.63,
    height: 73.061,
    viewBox: "0 0 88.63 73.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    d: "M63.776,45.854V38.069A15.569,15.569,0,0,0,48.207,22.5H17.069A15.569,15.569,0,0,0,1.5,38.069v7.785",
    transform: "translate(0 28.707)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M38.638,20.069A15.569,15.569,0,1,1,23.069,4.5,15.569,15.569,0,0,1,38.638,20.069Z",
    transform: "translate(9.569)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M41.677,45.543V37.758A15.569,15.569,0,0,0,30,22.7",
    transform: "translate(45.453 29.018)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    d: "M24,4.695A15.569,15.569,0,0,1,24,34.86",
    transform: "translate(35.884 0.311)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.5fe922285d4015fcb4468adb2f7d0041.svg";
export { ForwardRef as ReactComponent };